import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { setUnauthorizedHandler } from './api/axiosInstance';
import Providers from './Providers';
import { useAuth } from "./contexts/AuthContext";
import { useTabGuard } from './contexts/TabGuardContext';
// import { useSignalR } from './contexts/SignalRContext';
import { isMockMode } from './mocks/isMockMode';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Payout from './pages/Payout';
import ErrorPage from './pages/ErrorPage';
import DuplicateTabScreen from './components/DuplicateTabScreen';
import './styles/shared.scss';
import AppLayout from './AppLayout';

// Protected Route Wrapper
const ProtectedRoute = ({ children }) => {
  const isMockModeEnabled = isMockMode();
  const { isAuthenticated, setIsAuthenticated, setIsSessionTimedOut, setIsKickedOut, loading } = useAuth();
  const { isDuplicateTab } = useTabGuard();
  const location = useLocation();
  const navigate = useNavigate();
  // const { disconnect } = useSignalR();

  useEffect(() => {
    setUnauthorizedHandler(({ isTokenExpired } = {}) => {
      setIsAuthenticated(false);
      if (isTokenExpired) {
        setIsSessionTimedOut(true);
      } else {
        setIsKickedOut(true);
      }
      localStorage.clear();
      // disconnect();
      navigate('/', { replace: true });
    });
  }, [setIsAuthenticated, setIsSessionTimedOut, setIsKickedOut, navigate]);

  if (isMockModeEnabled) return children;
  if (loading) return <div>Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/" replace state={{ from: location.pathname }} />;
  if (isDuplicateTab) return <DuplicateTabScreen />;

  return children;
};

function App() {
  return (
    <Providers>
      <Router>
        <Routes>
          {/* Public Route: Login */}
          <Route path="/" element={ <Login /> } />

          {/* Protected Routes */}
          <Route element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
            }
          >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/payout" element={<Payout />} />
          </Route>

          {/* 404 Route */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Router>
    </Providers>
  );
}

export default App;
